import React from 'react';
import { emptyTranslation } from '@colonist/i18n';
import { Dialog, Image, T } from '@colonist/ui';
import styles from './RequestPushNotificationDialog.module.scss';
import IconFriends from '@static/images/icon_profile_friends.svg';
import IconLeaderboard from '@static/images/icon_profile_membership.svg';
import IconOffers from '@static/images/icon_colonist_coin.svg';
const DECORATIVE = emptyTranslation;
const PERKS = [
    {
        image: {
            src: IconFriends,
            alt: DECORATIVE
        },
        label: {
            key: 'strings:homePage.popups.requestPushNotification.friendRequests'
        }
    },
    {
        image: {
            src: IconLeaderboard,
            alt: DECORATIVE
        },
        label: {
            key: 'strings:homePage.popups.requestPushNotification.leaderboardUpdates'
        }
    },
    {
        image: {
            src: IconOffers,
            alt: DECORATIVE
        },
        label: {
            key: 'strings:homePage.popups.requestPushNotification.exclusiveOffers'
        }
    }
];
/** Opt-in dialog asking the user to enable push notifications. */ export function RequestPushNotificationDialog({ open, onClose, variant, onConfirm, onDecline }) {
    const handleConfirm = ()=>{
        onConfirm();
        onClose();
    };
    const handleDecline = ()=>{
        onDecline();
        onClose();
    };
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: handleDecline
    }, /*#__PURE__*/ React.createElement(Dialog.Title, null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:homePage.popups.requestPushNotification.title'
        }
    })), /*#__PURE__*/ React.createElement(Dialog.Content, null, variant == 'homePage' ? /*#__PURE__*/ React.createElement("ul", {
        className: styles.perks
    }, PERKS.map((perk)=>/*#__PURE__*/ React.createElement("li", {
            className: styles.perk,
            key: perk.label.key
        }, /*#__PURE__*/ React.createElement("span", {
            className: styles.perkIcon
        }, /*#__PURE__*/ React.createElement(Image, {
            className: styles.perkIconImage,
            image: perk.image
        })), /*#__PURE__*/ React.createElement(T, {
            id: perk.label
        })))) : /*#__PURE__*/ React.createElement("p", {
        className: styles.body
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:homePage.popups.requestPushNotification.friendRequestBody'
        }
    }))), /*#__PURE__*/ React.createElement(Dialog.ButtonFooter, null, /*#__PURE__*/ React.createElement(Dialog.ButtonFooter.CancelButton, {
        onClick: handleDecline
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:homePage.popups.requestPushNotification.notNow'
        }
    })), /*#__PURE__*/ React.createElement(Dialog.ButtonFooter.ConfirmButton, {
        onClick: handleConfirm
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:homePage.popups.requestPushNotification.notifyMe'
        }
    }))));
}
